<script>
  import { onMount } from "svelte";
  import { API_DIR, SESSION_LS, showLoadingModal } from "../store";
  import Th from "../Tables/Th.svelte";
  import ThFilter from "../Tables/ThFilter.svelte";
  import RowsPerPage from "../Tables/RowsPerPage.svelte";
  import RowCount from "../Tables/RowCount.svelte";
  import Pagination from "../Tables/Pagination.svelte";
  import { DataHandler, check, Datatable } from "@vincjo/datatables";
  import { convertUnixToDate } from "../Utils.svelte";
  import { toasts } from "svelte-toasts";

  let responseJsonData = [];

  let isMounted = false;
  let handler = new DataHandler(responseJsonData, { rowsPerPage: 20 });
  handler.applySorting({ orderBy: "date_created", order: "desc" });
  let rows = handler.getRows();
  let selected = handler.getSelected();
  let isAllSelected = handler.isAllSelected();
  let disabled;
  const allowedProperties = [
    "device_id",
    "filename",
    "date_created",
    "status",
    "auth",
    "act_type",
    "tag_group"
  ];

  async function cancelUpdate(jobId) {

    const confirmation = confirm("Are you sure you want to cancel this update queue?");

    if (!confirmation) {
      return;
    }
    
    try {
      showLoadingModal.set(true);

      const response = await fetch(`${$API_DIR}/api/v1/set-update-status`, {
        method: "POST",
        body: JSON.stringify({ update_id: jobId, new_status: "canceled" }),
        headers: {
          "Content-Type": "application/json",
          "Session-Id": localStorage.getItem("session_id")
        }
      });

      showLoadingModal.set(false);

      if (response.status === 401) {
        location.reload();
      }

      if (!response.ok) {
        toasts.error("Could not cancel update");
      }

      if (response.ok) {
        toasts.success("Update canceled");
        setUpTable();
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function fetchJobs() {
    try {
      showLoadingModal.set(true);

      const response = await fetch(`${$API_DIR}/api/v1/get-updates-queue`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Session-Id": localStorage.getItem($SESSION_LS)
        }
      });

      showLoadingModal.set(false);

      if (response.status === 401) {
        location.reload();
      }
      if (!response.ok) {
        toasts.error("Could not get updates queue");
      }
      const data = await response.json();

      if (data.length > 0) {
        return data;
      } else {
        return [];
      }
    } catch (error) {}
  }

  function addDeviceIdToJson() {
    for (let i = 0; i < responseJsonData.length; i++) {
      const deviceId = responseJsonData[i].job_id.slice(1, 11); // Obtener el device_id
      const jsonObject = { device_id: deviceId, ...responseJsonData[i] }; // Crear un nuevo objeto JSON

      // Reemplazar el objeto original con el nuevo objeto
      responseJsonData[i] = jsonObject;
    }
  }

  async function setUpTable() {
    responseJsonData = await fetchJobs();

    responseJsonData.forEach((update) => {
      if (!update.hasOwnProperty("tag_group")) {
        update.tag_group = "-";
      }
    });

    addDeviceIdToJson();
    handler = new DataHandler(responseJsonData, { rowsPerPage: 15 });
    handler.applySorting({ orderBy: "date_created", order: "desc" });
    rows = handler.getRows();
    selected = handler.getSelected();
    isAllSelected = handler.isAllSelected();
    disabled = true;
  }

  onMount(async () => {
    await setUpTable();
    isMounted = true;
  });
</script>

{#if isMounted}
  <hr />
  <div class="row">
    <div class="col-lg-6">
      <h2>Pending Updates</h2>
    </div>
    <div class="col-lg-6">
      <div class="d-flex justify-content-end">
        <div style="margin-top: 4px;">
          <RowsPerPage {handler} />
        </div>
      </div>
    </div>
  </div>
  <hr />

  <div class="table-responsive">
    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <!--<th class="selection">
              <input
                type="checkbox"
                on:click={() => handler.selectAll({ selectBy: "job_id" })}
                checked={$isAllSelected}
              />
            </th>-->

          <!--{#each Object.keys(responseJsonData[0]) as obj}
              {#if obj != "imsi" && obj != "job_id" && obj != "app_id" }
                <Th {handler} orderBy={obj}>{obj.toUpperCase()}</Th>
              {/if}
            {/each}-->

          <Th {handler} orderBy={"device_id"}>{"DEVICE ID"}</Th>
          <Th {handler} orderBy={"filename"}>{"FILENAME"}</Th>
          <Th {handler} orderBy={"date_created"}>{"DATE"}</Th>
          <Th {handler} orderBy={"status"}>{"STATUS"}</Th>
          <Th {handler} orderBy={"auth"}>{"AUTH"}</Th>
          <Th {handler} orderBy={"act_type"}>{"TYPE"}</Th>
          <Th {handler} orderBy={"tag_group"}>{"GROUP"}</Th>

          <th>CANCEL</th>
        </tr>
        <tr>
          <!--<th class="selection" />-->

          <!--{#each Object.keys(responseJsonData[0]) as obj}
              {#if obj != "imsi" && obj != "job_id" && obj != "app_id"}
                <ThFilter {handler} filterBy={obj} />
              {/if}
            {/each}-->

          <ThFilter {handler} filterBy={"device_id"} />
          <ThFilter {handler} filterBy={"filename"} />
          <ThFilter {handler} filterBy={"date_created"} />
          <ThFilter {handler} filterBy={"status"} />
          <ThFilter {handler} filterBy={"auth"} />
          <ThFilter {handler} filterBy={"act_type"} />
          <ThFilter {handler} filterBy={"tag_group"} />

          <th class="selection" />
        </tr>
      </thead>
      <tbody style="table-striped">
        {#each $rows as row}
          <!--<tr class:active={$selected.includes(row.filename)}>-->
          <tr>
            <!--<td class="selection">
                <input
                  type="checkbox"
                  on:click={() => handler.select(row.filename)}
                  checked={$selected.includes(row.filename)}
                />
              </td>-->

            {#each Object.keys(responseJsonData[0]) as obj}
              {#if allowedProperties.includes(obj)}
                {#if obj == "date_created" || obj == "auth" || obj == "status"}
                  {#if obj == "active"}
                    <td align="center" style="white-space: nowrap">
                      <div
                        class={row[obj.toString()] == true
                          ? " badge bg-success"
                          : "badge bg-secondary"}
                      >
                        {row[obj.toString()]}
                      </div>
                    </td>
                  {/if}

                  {#if obj == "auth"}
                    <td align="center" style="white-space: nowrap">
                      {#if row[obj.toString()] != ""}
                        <div class="badge bg-success">true</div>
                      {:else}
                        <div class="badge bg-secondary">false</div>
                      {/if}
                    </td>
                  {/if}

                  {#if obj == "id_group"}
                    <td align="center" style="white-space: nowrap">
                      {#if row[obj.toString()] != ""}
                        <div class="badge bg-success">true</div>
                      {:else}
                        <div class="badge bg-secondary">false</div>
                      {/if}
                    </td>
                  {/if}

                  {#if obj == "status"}
                    <td align="center" style="white-space: nowrap">
                      {#if row[obj.toString()] == "created"}
                        <div class="badge bg-info">
                          {row[obj.toString()]}
                        </div>
                      {:else if row[obj.toString()] == "processing"}
                        <div class="badge bg-warning">
                          {row[obj.toString()]}
                        </div>
                      {:else if row[obj.toString()] == "failed"}
                        <div class="badge bg-danger">
                          {row[obj.toString()]}
                        </div>
                      {:else if row[obj.toString()] == "canceled"}
                        <div class="badge bg-danger">
                          {row[obj.toString()]}
                        </div>
                      {:else}
                        <div class="badge bg-secondary">
                          {row[obj.toString()]}
                        </div>
                      {/if}
                    </td>
                  {/if}

                  {#if obj == "date_created"}
                    <td align="center" style="white-space: nowrap">
                      {convertUnixToDate(row[obj])}
                    </td>
                  {/if}
                {:else}
                  <td align="center" style="white-space: nowrap"
                    >{row[obj.toString()]}</td
                  >
                {/if}
              {/if}
            {/each}

            <td align="center" style="white-space: nowrap">
              <button
                type="button"
                class="btn btn-outline-danger"
                on:click={cancelUpdate(row.job_id)}
                ><i class="bi bi-x-square" /></button
              >
            </td>
          </tr>
        {/each}
      </tbody>
    </table>
  </div>

  <br />

  <div class="row">
    <div class="col d-flex justify-content-end">
      <RowCount {handler} />
      <div style="width: 12px;" />
      <Pagination {handler} />
    </div>
  </div>

  <br />
{/if}

<style>
</style>
